import type { ReactNode } from "react"

import { DialogContext } from "./DialogContext"
import type { DialogOptions } from "./DialogOptions"
import { useDialog } from "./useDialog"

export interface Props extends DialogOptions {
  children: ReactNode;
}

/*
 * the dialog renders a prompt in a box that is overlaid on top of the rest of
 * the page with a backdrop that darkens all of the content behind it
 *
 * the dialog gives the user the opportunity to respond to a prompt usually by
 * confirming or canceling
 *
 * if the backdrop is clicked, the escape button is pressed, or the clsoe
 * button is pressed, it is considered the same as clicking "cancel"
 */
export function Dialog({
  children,
  ...options
}: Props) {
  const dialog = useDialog(options)

  return (
    <DialogContext.Provider value={dialog}>
      {children}
    </DialogContext.Provider>
  )
}
